import { render } from "./LetterPreview.vue?vue&type=template&id=698c3ed5&scoped=true"
import script from "./LetterPreview.vue?vue&type=script&lang=js"
export * from "./LetterPreview.vue?vue&type=script&lang=js"

import "./LetterPreview.vue?vue&type=style&index=0&id=698c3ed5&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698c3ed5"]])

export default __exports__